import { Link } from "react-router-dom";
import { Typography } from "@mui/material";


const unitMapping = (unit) => {
    const unitSymbol = {
        'milliliter' : 'mL',
        'liter' : 'L'
    }
    return unitSymbol?.[unit] || "";
}

export const mapProductNames = (orderProducts) => {
    return orderProducts?.length
        ? orderProducts.reduce((all, item) => {
            const displayProductInfo = item?.displayInfo
            all[item.materialMasterId] = `${displayProductInfo?.name} - ${displayProductInfo?.description} - ${displayProductInfo?.displayAge}`;
            return all;
        }, {})
        : {};
}

export const mapProductNamesFormatted = (orderProducts) => {
    return orderProducts?.length
        ? orderProducts.reduce((all, item) => {
            const displayProductInfo  = item?.displayInfo;
            const hasDisplayAge = displayProductInfo?.displayAge?.length > 0;
            const description = displayProductInfo?.description || '';
            const mlIndex = description.indexOf('mL');
            let desc1 = description;
            let desc2 = '';

            if (mlIndex !== -1) {
                desc1 = description.substring(0, mlIndex + 2);
                desc2 = description.substring(mlIndex + 2);
            }
            all[item.materialMasterId] = (
                <div>
                    <span style={{ fontWeight: "700"}}>{displayProductInfo?.name}</span>
                    <span>
                        <br />
                        <span style={{ color: "#1858CD", fontWeight: "700" }}>{desc1}</span>
                        <span style={{ fontWeight: "400"}}>{desc2}{hasDisplayAge ? ` - ${displayProductInfo.displayAge}` : ""}
                        </span>
                    </span>
                </div>
            );
            return all;
        }, {})
        : {};
}

export const getPricingInfo = (allPrices) => {
    let productPricingMap = allPrices?.productPrices.reduce((all, productPrice) => {
        return {
            ...all,
            [productPrice?.productId]: {
                listPrice: productPrice?.listPriceFormatted,
                contractPrice: productPrice?.finalPriceFormatted
            }
        }
    }, {}) || {};
    return productPricingMap;
}

export const convertUserDataAddressToCartData = (userDataAddress) => {
    return {
        "addressId": String(userDataAddress?.id),
        "street1": userDataAddress?.line1 ,
        "street2": userDataAddress?.line2 ,
        "city": userDataAddress?.city ,
        "state": userDataAddress?.state ,
        "zipCode": userDataAddress?.zip,
        "zipExtraFour": userDataAddress?.zipExtension ,
        "name": userDataAddress?.dba ,
        "contactInfo": {
            "name": userDataAddress?.contactName,
            "email": userDataAddress?.contactEmail,
            "phone": userDataAddress?.contactPhone,
        }
    };
};

export const convertCartDataAddressToUserData = (cartDataAddress) => {
    return {
        id: cartDataAddress?.addressId,
        line1: cartDataAddress?.street1,
        line2: cartDataAddress?.street2,
        city: cartDataAddress?.city,
        state: cartDataAddress?.state,
        zip: cartDataAddress?.zipCode,
        zipExtension: cartDataAddress?.zipExtraFour,
        dba: cartDataAddress?.name,
        contactName: cartDataAddress?.contactInfo?.name,
        contactEmail: cartDataAddress?.contactInfo?.email,
        contactPhone: cartDataAddress?.contactInfo?.phone,
    };
};

export const getLicenseName = (license) => {
    let licenseName = license?.licenseType === 'medical' ? 
    `${license?.firstName} ${license?.lastName}` : license?.name;
    return licenseName
}

export const getMedicalLicense = (licenseSelection) => {
    return {
        name: getLicenseName(licenseSelection),
        state: licenseSelection?.state,
        licenseNumber: licenseSelection?.number,
        expirationDate: licenseSelection?.expiration,
        licenseType: "STATE",
    }
}

export const getRoundedDoseMessage = (adjustedDoseQty) => {
    return `Doses rounded up to ${adjustedDoseQty}`;
}

export const generateConsentMessage = () => {
    let locale = "en-US";
    
    const links = [
        { label: "Conditions of Use", path: "/terms-of-use" },
        { label: "Privacy Policy", path: "/privacy-policy" },
        { label: "Terms and Conditions of Sale", path: "/terms-and-conditions-of-sale" },
    ];

    return (
        <Typography variant="body2">
            I agree to Moderna's&nbsp;
            {links.map((link, index) => (
                <span key={link.path}>
                    <Link to={`/${locale}${link.path}`} target="_blank" style={{ fontSize: "16px" }}>
                        {link.label}
                    </Link>
                    {index < links.length - 1 ? ", " : "."}
                </span>
            ))}
        </Typography>
    );
};
